import { Component } from '@angular/core';
import { FileUploadService } from '../../../services/file-upload.service';

@Component({
  selector: 'app-employ-upload',
  standalone: false,
  templateUrl: './employ-upload.component.html',
  styleUrl: './employ-upload.component.css'
})
export class EmployUploadComponent {
selectedFile!: File;

  constructor(private fileUploadService: FileUploadService) {}

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
    }
  }

  onUpload(): void {
    if (this.selectedFile) {
      this.fileUploadService.uploadFile(this.selectedFile).subscribe({
        next: (response) => console.log('Éxito:', response),
        error: (error) => console.error('Error:', error),
      });
    }
  }
  
}
